// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/booking_types.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/booking_types.proto.
 */
export const file_proto_model_booking_booking_types = /*@__PURE__*/
  fileDesc("Cidwcm90by9tb2RlbC9ib29raW5nL2Jvb2tpbmdfdHlwZXMucHJvdG8SBmNhcm1lbir6AQoNUGFzc2VuZ2VyVHlwZRIeChpQQVNTRU5HRVJfVFlQRV9VTlNQRUNJRklFRBAAEhgKFFBBU1NFTkdFUl9UWVBFX0FEVUxUEAESGAoUUEFTU0VOR0VSX1RZUEVfQ0hJTEQQAhIZChVQQVNTRU5HRVJfVFlQRV9JTkZBTlQQAxImCiJQQVNTRU5HRVJfVFlQRV9JTkZBTlRfV0lUSE9VVF9TRUFUEAQSGQoVUEFTU0VOR0VSX1RZUEVfU0VOSU9SEAUSGgoWUEFTU0VOR0VSX1RZUEVfU1RVREVOVBAGEhsKF1BBU1NFTkdFUl9UWVBFX01JTElUQVJZEAcqiAEKCFNlYXRUeXBlEhkKFVNFQVRfVFlQRV9VTlNQRUNJRklFRBAAEhUKEVNFQVRfVFlQRV9FQ09OT01ZEAESHQoZU0VBVF9UWVBFX1BSRU1JVU1fRUNPTk9NWRACEhYKElNFQVRfVFlQRV9CVVNJTkVTUxADEhMKD1NFQVRfVFlQRV9GSVJTVBAEKt4BCg1Cb29raW5nU3RhdHVzEh4KGkJPT0tJTkdfU1RBVFVTX1VOU1BFQ0lGSUVEEAASGwoXQk9PS0lOR19TVEFUVVNfUkVTRVJWRUQQARIXChNCT09LSU5HX1NUQVRVU19QQUlEEAISHAoYQk9PS0lOR19TVEFUVVNfQ09ORklSTUVEEAQSHQoZQk9PS0lOR19TVEFUVVNfQ0hFQ0tFRF9JThAIEhwKGEJPT0tJTkdfU1RBVFVTX0NPTVBMRVRFRBAQEhwKGEJPT0tJTkdfU1RBVFVTX0NBTkNFTExFRBAgKqwCCg9Db21taXRtZW50U3RhdGUSIAocQ09NTUlUTUVOVF9TVEFURV9VTlNQRUNJRklFRBAAEh4KGkNPTU1JVE1FTlRfU1RBVEVfVEVOVEFUSVZFEAESIAocQ09NTUlUTUVOVF9TVEFURV9DQU5DRUxMQUJMRRACEi8KK0NPTU1JVE1FTlRfU1RBVEVfQ0FOQ0VMTEFCTEVfUEFSVElBTF9SRUZVTkQQAxInCiNDT01NSVRNRU5UX1NUQVRFX0NBTkNFTExBQkxFX0NSRURJVBAEEhsKF0NPTU1JVE1FTlRfU1RBVEVfTE9DS0VEEAUSHgoaQ09NTUlUTUVOVF9TVEFURV9DT01QTEVURUQQBhIeChpDT01NSVRNRU5UX1NUQVRFX0NBTkNFTExFRBAHQj5CDEJvb2tpbmdUeXBlc1ouZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWwvYm9va2luZ2IGcHJvdG8z");

/**
 * Describes the enum carmen.PassengerType.
 */
export const PassengerTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_booking_types, 0);

/**
 * Passenger type classification for flight bookings
 *
 * @generated from enum carmen.PassengerType
 */
export const PassengerType = /*@__PURE__*/
  tsEnum(PassengerTypeSchema);

/**
 * Describes the enum carmen.SeatType.
 */
export const SeatTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_booking_types, 1);

/**
 * Seat type classification for flight bookings
 *
 * @generated from enum carmen.SeatType
 */
export const SeatType = /*@__PURE__*/
  tsEnum(SeatTypeSchema);

/**
 * Describes the enum carmen.BookingStatus.
 */
export const BookingStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_booking_types, 2);

/**
 * Represents the current state of the booking process
 *
 * @generated from enum carmen.BookingStatus
 */
export const BookingStatus = /*@__PURE__*/
  tsEnum(BookingStatusSchema);

/**
 * Describes the enum carmen.CommitmentState.
 */
export const CommitmentStateSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_booking_types, 3);

/**
 * Represents how committed we are to this booking
 * Used to determine if it's safe to drop when modifying schedule
 *
 * @generated from enum carmen.CommitmentState
 */
export const CommitmentState = /*@__PURE__*/
  tsEnum(CommitmentStateSchema);

